import React, { useContext } from 'react';
import { RicosContext } from './RicosContext.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ToolbarContext = React.createContext({
  contentId: "",
  isMobile: false,
  theme: {},
  locale: "en",
  helpers: {},
  plugins: [],
  linkPanelData: void 0,
  headingsData: void 0,
  linkSettings: {},
  experiments: {},
  toolbarSettings: {},
  getEditorCommands: () => ({}),
  portal: null,
  toolbars: null,
  colorPickerData: {},
  defaultLineSpacing: {}
});
const withToolbarContext = (WrappedComponent) => {
  return (props) => {
    const { t } = useContext(RicosContext);
    return /* @__PURE__ */ React.createElement(ToolbarContext.Consumer, null, (contexts) => /* @__PURE__ */ React.createElement(WrappedComponent, __spreadProps(__spreadValues({}, props), { context: __spreadProps(__spreadValues({}, contexts), { t }) })));
  };
};

export { ToolbarContext, withToolbarContext };
//# sourceMappingURL=ToolbarContext.js.map
